/* eslint-disable no-unused-vars*/
import React, { useState, useCallback } from 'react';
import { getCookie } from 'helper/cookie';
import { Button, Row, Col, Form, Space, Select, Input, Tabs, Tooltip, message, Modal } from 'antd';
import {
  Container,
  DealerTable,
  DetailButton,
  DropdownContainer,
  Header,
  PastelButton,
  RegisterButtton,
  SaveButton,
  Section,
  StatusContainer,
  StatusLabel,
  StyledInDetailTableDealer,
  StyledModal,
  StyledRadioButton,
  StyledRadioGroup,
  StyledTabsDealer,
  StyledTag,
  TableCell,
  TableHeader,
  TableRow,
} from './dealer.styles';
import { getCustomerAll } from 'api/customer';
import Swal from 'sweetalert2';
import {
  deleteMapping,
  getDealerAll,
  getDealerMappingMyIncome,
  getDealerMappingMyRegister,
  postCreateDealerMappingPayrateGenerateUser,
  postCreateDealerMappingPayrateUser,
  postRegisterDealer,
  updateCreditsDealer,
  updateCreditsLimitDealer,
  updateMappingGenerateKey,
  updateMappingUpdateStatus,
} from 'api/dealer';
import { SwalAlert } from 'common/Swal/swal.common';
const { Option } = Select;
import Color from 'constants/color';
import { DetailIconDealer } from 'common/SVG/svg.common';
import { getLotteryTypeAll } from 'api/lotteryType';
import { getTypeNumberAll } from 'api/typeNumber';
import { getPayrateUserById } from 'api/payrateUser';
import { CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getPayrateAll, getPayrateMyGruopUserAll } from 'api/payrate';
import { NumberFormat } from 'helper/currency';
import { messageRequireIcon } from 'common/messageError/message.common';
import { PastelRadioGroup } from 'common/Card/StylesCard.common';

const DealerComponents = () => {
  const token = getCookie('access_tokenltl');
  const [form] = Form.useForm();
  const dataUser: any = getCookie('dataUser');
  const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
  const [myRegisterDealer, setMyRegisterDealer] = useState<any>([]);
  const [myIncomeDealer, setMyIncomeDealer] = useState<any>([]);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [dataOwner, setDataOwner] = useState<any>([]);
  const [isLoadingOwner, setIsLoadingOwner] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataLotteryTypeList, setDataLotteryTypeList] = useState<any>([]);
  const [tabData, setTabData] = useState<any>({});
  const [dataTypeNumberData, setTypeNumberData] = useState<any>([]);
  const [tableData, setTableData] = useState([]);
  const [dealerUserId, setDealerUserId] = useState(0);
  const [ownerId, setOwnerId] = useState(0);
  const [showKeyGenerate, setShowKryGenerate] = useState('');
  const [registrationKey, setRegistrationKey] = useState('');
  const [dataPayrateList, setDataPayrateList] = useState<any>([]);
  const [isLoadingPayrateList, setIsLoadingPayrateList] = useState(true);
  const [activeTab, setActiveTab] = useState<string | null>('1');
  const [selectedPayrate, setSelectedPayrate] = useState<string | null>(null);
  const [thisMyUserId, setThisMyUserId] = useState(0);
  const [payrateStatus, setPayrateStatus] = useState<string>('Y'); // Default to 'Y'
  const [dealerDataShowPopUp, setDealerDataShowPopUp] = useState<any>([]);
  const [isMaxCreditModalVisible, setIsMaxCreditModalVisible] = useState(false);
  const [isAvailableCreditModalVisible, setIsAvailableCreditModalVisible] = useState(false);
  const [maxCredit, setMaxCredit] = useState<any>('');
  const [availableCredit, setAvailableCredit] = useState<any>('');
  const [maxCreditLimit, setMaxCreditLimit] = useState<any>('');

  const [isModalGenerateKeyVisible, setIsModalGenerateKeyVisible] = useState(false);

  const [isModalShowGenerateKey, setIsModalShowGenerateKey] = useState(false);
  const [nickname, setNickname] = useState(''); // เพิ่ม state สำหรับชื่อเรียก

  const [dataShowKey, setDataShowKey] = useState<any>([]);

  const [showEdit, setShowEdit] = useState(false);

  const [checked, setChecked] = useState('N');

  const [isModalVisibleUpdate, setIsModalVisibleUpdate] = useState(false);
  const [isModalVisibleViewOnly, setIsModalVisibleViewOnly] = useState(false);

  // ฟังก์ชันสำหรับเปิด/ปิด Modal สำหรับการ update
  // const showModalUpdate = () => setIsModalVisibleUpdate(true);
  // const handleOkUpdate = () => setIsModalVisibleUpdate(false);
  // const handleCancelUpdate = () => setIsModalVisibleUpdate(false);

  // ฟังก์ชันสำหรับเปิด/ปิด Modal สำหรับการ view
  // const showModalViewOnly = () => setIsModalVisibleViewOnly(true);
  // const handleOkViewOnly = () => setIsModalVisibleViewOnly(false);
  // const handleCancelViewOnly = () => setIsModalVisibleViewOnly(false);

  const options = [
    { label: 'เกินยอดที่เรารับได้', value: 'Y' },
    { label: 'ไม่สามารถเกินยอดที่เรารับได้', value: 'N' },
  ];

  const fetchShowGenerateKey = useCallback(
    async (query?: any) => {
      const params = {
        order_by: 'id',
        order_type: 'DESC',
        owner_id: parseDataUser.id,
      };
      try {
        const responseData = await getDealerAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataShowKey(data?.data?.dealer);
        } else {
          setDataShowKey([]);
        }
      } catch (error) {}
    },
    [token],
  );

  useMemo(() => {
    if (token) {
      fetchShowGenerateKey();
    }
  }, [token, fetchShowGenerateKey]);

  const fetchPayrateList = useCallback(
    async (query?: any) => {
      setIsLoadingPayrateList(true);
      const params = {
        order_by: 'id',
        order_type: 'ASC',
        limit: 999,
      };
      try {
        const responseData = await getPayrateMyGruopUserAll({
          token,
          params: params,
        });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataPayrateList(data?.data?.payrate);
          setIsLoadingPayrateList(false);
        } else {
          setDataPayrateList([]);
          setIsLoadingPayrateList(false);
        }
      } catch (error) {
        setIsLoadingPayrateList(false);
      }
    },
    [token],
  );

  useMemo(() => {
    if (token) {
      fetchPayrateList();
    }
  }, [token, fetchPayrateList]);

  const renderPayrateList = () => {
    if (isLoadingPayrateList === false) {
      return dataPayrateList?.map((value: any, index: number) => {
        return (
          <Option value={value.id} key={index}>
            {value.payrate_name}
          </Option>
        );
      });
    }
    return [];
  };

  const handleInputChangeRegisterKey = (e: any) => {
    setRegistrationKey(e.target.value);
  };

  const initializeTabData = () => {
    const payrateData = tableData.reduce((acc: any, item: any) => {
      if (thisMyUserId === 0) {
        setThisMyUserId(item?.payrate_user_user_id);
      }
      if (!acc[item.lottery_type_id]) {
        acc[item.lottery_type_id] = [];
      }
      acc[item.lottery_type_id].push(item);
      return acc;
    }, {});

    return dataLotteryTypeList.reduce((acc: any, item: any) => {
      const initialData = dataTypeNumberData.map((data: any) => ({
        ...data,
        id: 0,
        lottery_type_id: item.id,
        payrate_user_group_id: 1,
        payrate_user_name: null,
        payrate_user_type_id: data.id,
        payrate_user_type_slug: data.type_number_slug,
        payrate_user_type_name: data.type_number_name,
        payrate_user_price: null,
        payrate_user_discount: null,
        payrate_user_blockprice: null,
        payrate_user_kooh: null,
        payrate_user_user_id: null,
        payrate_user_group_user_id: 2,
        count_active_periods: 0,
        period_data: [],
      }));

      acc[item.id] = { ...item };

      if (payrateData[item.id]) {
        const payrateDataMap = payrateData[item.id].reduce((map: any, payrate: any) => {
          map[payrate.payrate_user_type_slug] = payrate;
          return map;
        }, {});

        acc[item.id].payrate_data = initialData.map((data: any) => {
          const matchedPayrate = payrateDataMap[data.type_number_slug];
          return {
            ...data,
            ...matchedPayrate,
            type_number_name: data.type_number_name,
          };
        });
      } else {
        acc[item.id].payrate_data = initialData;
      }

      return acc;
    }, {});
  };

  useEffect(() => {
    if (dataLotteryTypeList?.length && dataTypeNumberData.length) {
      setTabData(initializeTabData());
    }
  }, [dataLotteryTypeList, dataTypeNumberData, tableData]);

  const knownFields = [
    'id',
    'lottery_type_id',
    'payrate_user_group_id',
    'payrate_user_name',
    'payrate_user_type_id',
    'payrate_user_type_slug',
    'payrate_user_type_name',
    'payrate_user_price',
    'payrate_user_discount',
    'payrate_user_blockprice',
    'payrate_user_kooh',
    'payrate_user_user_id',
    'payrate_user_group_user_id',
    'created_at',
    'updated_at',
    'count_active_periods',
    'period_data',
  ];

  const filterKnownFields = (data: any) => {
    return data.map((item: any) => {
      const filteredItem: any = {};
      Object.keys(item).forEach((key: any) => {
        if (knownFields.includes(key)) {
          filteredItem[key] = item[key];
        }
      });
      return filteredItem;
    });
  };

  const fetchTypeNumberList = useCallback(
    async (query?: any) => {
      const params = {
        type_number_show: 'Y',
        order_by: 'id',
        order_type: 'ASC',
      };
      try {
        const responseData = await getTypeNumberAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setTypeNumberData(data?.data?.type_number);
        } else {
          setTypeNumberData([]);
        }
      } catch (error) {}
    },
    [token],
  );

  useMemo(async () => {
    if (token) {
      await fetchTypeNumberList();
    }
  }, [token]);

  const fetchCustomerOwnerGroupId = useCallback(
    async (query?: any) => {
      setIsLoadingOwner(true);

      const params = {
        groupuser_id: query?.groupuser_id,
        type: 'Owner',
      };
      // console.log(params)
      try {
        const responseData = await getCustomerAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataOwner(data?.data?.customer[0]);
          setIsLoadingOwner(false);
        } else {
          setDataOwner([]);
          setIsLoadingOwner(false);
        }
      } catch (error) {
        setIsLoadingOwner(false);
      }
    },
    [token],
  );

  useMemo(async () => {
    await fetchCustomerOwnerGroupId();
  }, [token]);

  const fetchLotteryTypeList = useCallback(
    async (query?: any) => {
      const params = {
        ids: query?.lottery_type,
        order_by: 'lottery_type_sort',
        order_type: 'ASC',
        lottery_type_status: 'Y',
        limit: 99,
      };
      try {
        const responseData = await getLotteryTypeAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          const dataLotteryType = data?.data?.lottery_type;
          setDataLotteryTypeList(dataLotteryType);
        } else {
          setDataLotteryTypeList([]);
        }
      } catch (error) {}
    },
    [token],
  );

  useMemo(async () => {
    if (!isLoadingOwner) {
      await fetchLotteryTypeList(dataOwner);
    }
  }, [isLoadingOwner]);

  const showModal = async (id: number, owner_id: number, action: string) => {
    setIsModalVisibleViewOnly(false);

    const params = {
      id: id,
      owner_id: owner_id,
      order_by: ['lottery_type_id', 'payrate_user_type_id'],
      order_type: 'ASC',
    };

    const paramsData = {
      dealer_user_id: id,
      owner_id: owner_id,
    };

    // console.log('id',id)

    setDealerUserId(id);
    setOwnerId(owner_id);

    try {
      const responseData = await getPayrateUserById({ token, params: params });
      const responseDataDealer = await getDealerAll({
        token,
        params: paramsData,
      });
      if (responseDataDealer?.status === 200) {
        const dealerData = responseDataDealer?.data?.data?.dealer[0];
        setDealerDataShowPopUp(dealerData);
        setPayrateStatus(dealerData?.dealer_mapping_status_income);
        setMaxCredit(dealerData?.dealer_mapping_credits_limit);
        setAvailableCredit(dealerData?.dealer_mapping_credits);
        setNickname(dealerData?.dealer_name);
        setChecked(dealerData?.beyond_balance);
      } else {
        setDealerDataShowPopUp([]);
      }

      //   console.log('responseDataDealer',responseDataDealer)
      if (responseData?.status === 200) {
        const data = responseData?.data?.data;
        setTableData(data);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTableData([]);
    }
    setShowEdit(true);
    setIsModalVisible(true);
  };

  const showModalViewOnly = async (id: number, owner_id: number, action: string) => {
    // console.log('action', action);
    if (action === 'view') {
      const params = {
        id: id,
        owner_id: owner_id,
        order_by: ['lottery_type_id', 'payrate_user_type_id'],
        order_type: 'ASC',
      };

      const paramsData = {
        dealer_user_id: id,
        owner_id: owner_id,
      };

      // console.log('id',id)
      setDealerUserId(id);
      setOwnerId(owner_id);

      try {
        const responseData = await getPayrateUserById({
          token,
          params: params,
        });
        const responseDataDealer = await getDealerAll({
          token,
          params: paramsData,
        });
        if (responseDataDealer?.status === 200) {
          const dealerData = responseDataDealer?.data?.data?.dealer[0];
          // console.log('dealerData',dealerData)
          setDealerDataShowPopUp(dealerData);
          setPayrateStatus(dealerData?.dealer_mapping_status_income);
          setMaxCredit(dealerData?.dealer_mapping_credits_limit);
          setAvailableCredit(dealerData?.dealer_mapping_credits);
          setNickname(dealerData?.dealer_name);
          setChecked(dealerData?.beyond_balance);
        } else {
          setDealerDataShowPopUp([]);
        }

        //   console.log('responseDataDealer',responseDataDealer)
        if (responseData?.status === 200) {
          const data = responseData?.data?.data;
          setTableData(data);
        } else {
          setTableData([]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setTableData([]);
      }
      setShowEdit(false);
      setIsModalVisibleViewOnly(true);
    }
  };

  const handleOk = async (action: string) => {
    const allData = Object.values(tabData).flatMap((item: any) => item.payrate_data);
    const filteredData = filterKnownFields(allData);
    const params = {
      owner_id: ownerId,
      dealer_user_id: dealerUserId,
      dealer_mapping_status_income: payrateStatus,
      payrate_user: [...filteredData],
      dealer_name: nickname,
      beyond_balance: checked,
    };
    const createData = await postCreateDealerMappingPayrateUser({
      token,
      params: params,
    });
    if (createData?.status === 200) {
      await fetchCustomerOwnerGroupId();
      await fetchGetDealerMappingMyRegister();
      await fetchGetDealerMappingMyIncome();
      Swal.fire({
        icon: 'success',
        title: 'อัปเดตสำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'อัปเดตไม่สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    }
    // console.log('Sending data to API:', filteredData);
    if (action === 'view') {
      setIsModalVisibleViewOnly(false);
    } else {
      setIsModalVisible(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCancelViewOnly = () => {
    setIsModalVisibleViewOnly(false);
  };

  const handleGenerateKeyOk = async () => {
    if (!showKeyGenerate) {
      Swal.fire({
        icon: 'error',
        title: 'กรุณาสร้างข้อมูลคีย์ก่อน',
        showConfirmButton: false,
        timer: 5000,
      });
      return false;
    }
    const allData = Object.values(tabData).flatMap((item: any) => item.payrate_data);
    const filteredData = filterKnownFields(allData);
    const params = {
      owner_id: parseDataUser?.id,
      dealer_user_id: null,
      dealer_mapping_status_income: payrateStatus,
      payrate_user: [...filteredData],
      payrate_user_generate_key: showKeyGenerate,
      dealer_mapping_credits_limit: maxCreditLimit,
      dealer_mapping_credits: availableCredit,
      dealer_name: nickname,
    };
    const createData = await postCreateDealerMappingPayrateGenerateUser({
      token,
      params: params,
    });
    if (createData?.status === 200) {
      await fetchCustomerOwnerGroupId();
      await fetchGetDealerMappingMyRegister();
      await fetchGetDealerMappingMyIncome();
      Swal.fire({
        icon: 'success',
        title: 'สร้างคีย์สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'สร้างคีย์ไม่สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    }
    setIsModalGenerateKeyVisible(false);
  };

  const handleNicknameChange = (e: any) => {
    setNickname(e.target.value);
  };

  const handleGenerateKeyCancel = () => {
    setIsModalGenerateKeyVisible(false);
  };

  const showMaxCreditModal = () => {
    setIsMaxCreditModalVisible(true);
  };

  const handleMaxCreditCancel = () => {
    setIsMaxCreditModalVisible(false);
  };

  const showAvailableCreditModal = () => {
    setIsAvailableCreditModalVisible(true);
  };

  const handleShowGenerateKeyCancel = () => {
    setIsModalShowGenerateKey(false);
  };

  const handleMaxCreditOk = async () => {
    const params = {
      credits_limit: maxCredit,
      id: dealerDataShowPopUp?.id,
    };
    const paramsData = {
      dealer_user_id: dealerUserId,
      owner_id: ownerId,
    };

    const updateData = await updateCreditsLimitDealer({
      token,
      params: params,
    });
    const { status, error, message } = updateData;
    if (status === 200) {
      Swal.fire({
        title: 'ปรับวงเงินสูงสุดสำเร็จ',
        // text: 'Success',
        icon: 'success',
        confirmButtonText: 'Close',
        showConfirmButton: false,
      });
      const responseDataDealer = await getDealerAll({
        token,
        params: paramsData,
      });
      if (responseDataDealer?.status === 200) {
        const dealerData = responseDataDealer?.data?.data?.dealer[0];
        // console.log('dealerData',dealerData)
        setDealerDataShowPopUp(dealerData);
        setPayrateStatus(dealerData?.dealer_mapping_status_income);
        setMaxCredit(dealerData?.dealer_mapping_credits_limit);
        setAvailableCredit(dealerData?.dealer_mapping_credits);
      }
      setIsMaxCreditModalVisible(false);
    } else {
      Swal.fire({
        title: message,
        text: 'ปรับวงเงินสูงสุดไม่สำเร็จ',
        icon: 'error',
        showConfirmButton: false,
        confirmButtonText: 'Close',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
      setIsMaxCreditModalVisible(false);
    }
    setIsMaxCreditModalVisible(false);
  };

  const onChangeInputValue = (e: any, type: string) => {
    const { value } = e.target;
    let newValue = Number(value);
    if (type === 'credits_limit') {
      if (newValue >= Number(dealerDataShowPopUp?.dealer_mapping_credits_limit)) {
        setMaxCredit(value);
      } else {
        setMaxCredit(value);
      }
    } else {
      if (newValue >= Number(maxCredit)) {
        setAvailableCredit(maxCredit);
      } else {
        setAvailableCredit(value);
      }
    }
  };

  const handleAvailableCreditOk = async () => {
    const params = {
      credits: availableCredit,
      id: dealerDataShowPopUp?.id,
    };
    const paramsData = {
      dealer_user_id: dealerUserId,
      owner_id: ownerId,
    };
    const updateData = await updateCreditsDealer({ token, params: params });
    const { status, error, message } = updateData;
    if (status === 200) {
      const responseDataDealer = await getDealerAll({
        token,
        params: paramsData,
      });
      if (responseDataDealer?.status === 200) {
        const dealerData = responseDataDealer?.data?.data?.dealer[0];
        // console.log('dealerData',dealerData)
        setDealerDataShowPopUp(dealerData);
        setPayrateStatus(dealerData?.dealer_mapping_status_income);
        setMaxCredit(dealerData?.dealer_mapping_credits_limit);
        setAvailableCredit(dealerData?.dealer_mapping_credits);
      }
      Swal.fire({
        title: 'ปรับวงเงินที่ได้ใช้สำเร็จ',
        // text: 'Success',
        icon: 'success',
        confirmButtonText: 'Close',
        showConfirmButton: false,
      });
      // console.log(updateData)
      // await fetchCustomerById(id);
      setIsAvailableCreditModalVisible(false);
    } else {
      Swal.fire({
        title: message,
        text: 'ปรับวงเงินที่ได้ใช้ไม่สำเร็จ',
        icon: 'error',
        showConfirmButton: false,
        confirmButtonText: 'Close',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
      setIsAvailableCreditModalVisible(false);
    }
    setIsAvailableCreditModalVisible(false);
  };

  const handleAvailableCreditCancel = () => {
    setIsAvailableCreditModalVisible(false);
  };

  // const handleInputChange = (value: any, lotteryTypeId: any, payrateUserTypeId: any, column: any) => {
  //    setTabData((prevTabData: any) => {
  //      const newTabData: any = { ...prevTabData };
  //      Object.keys(newTabData).forEach((tabKey: any) => {
  //        if (Number(tabKey) === lotteryTypeId) {
  //          newTabData[tabKey].payrate_data = newTabData[tabKey].payrate_data.map((item: any) => {
  //            if (item.payrate_user_type_id === payrateUserTypeId) {
  //              return { ...item, [column]: value };
  //            }
  //            return item;
  //          });
  //        }
  //      });
  //      return newTabData;
  //    });
  //  };

  const handleInputChange = (value: string, lotteryTypeId: number, payrateTypeId: number, key: string) => {
    const updatedTabData = { ...tabData };
    if (updatedTabData[lotteryTypeId]) {
      updatedTabData[lotteryTypeId].payrate_data = updatedTabData[lotteryTypeId].payrate_data.map((item: any) => {
        if (item.payrate_user_type_id === payrateTypeId) {
          return {
            ...item,
            [key]: value,
          };
        }
        return item;
      });
    }
    setTabData(updatedTabData);
  };

  const columns = [
    {
      title: 'ชนิด',
      dataIndex: 'type_number_name',
      key: 'type_number_name',
    },
    {
      title: 'ราคาจ่าย',
      dataIndex: 'payrate_user_price',
      key: 'payrate_user_price',
      render: (text: any, record: any) => {
        return (
          <Input
            value={text} // Use value instead of defaultValue
            disabled={record?.payrate_user_user_id === parseDataUser?.id}
            style={{ color: '#000000' }}
            onChange={e => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 3); // กรองเฉพาะตัวเลขและจำกัดไม่เกิน 3 ตัวอักษร
              handleInputChange(value, record.lottery_type_id, record.payrate_user_type_id, 'payrate_user_price');
            }}
            onKeyPress={(e: any) => {
              if (!/[0-9]/.test(e.key) || e.target.value.length >= 3) {
                // ป้องกันการป้อนตัวอักษรที่ไม่ใช่ตัวเลขหรือเกิน 3 ตัวอักษร
                e.preventDefault();
              }
            }}
          />
        );
      },
    },
    {
      title: 'ส่วนลด%',
      dataIndex: 'payrate_user_discount',
      key: 'payrate_user_discount',
      render: (text: any, record: any) => (
        <Input
          value={text} // Use value instead of defaultValue
          style={{ color: '#000000' }}
          disabled={record?.payrate_user_user_id === parseDataUser?.id}
          onChange={e => {
            let value = e.target.value.replace(/\D/g, ''); // กรองเฉพาะตัวเลข
            if (value.length > 3) {
              value = value.slice(0, 3); // จำกัดความยาวไม่เกิน 3 ตัวอักษร
            }
            if (parseInt(value) > 100) {
              value = '100'; // ถ้าค่ามากกว่า 100 ให้ตั้งค่าเป็น 100
            }
            handleInputChange(value, record.lottery_type_id, record.payrate_user_type_id, 'payrate_user_discount');
          }}
          onKeyPress={(e: any) => {
            const inputValue = e.target.value + e.key; // ค่าปัจจุบันรวมกับค่าที่กำลังป้อน
            if (!/[0-9]/.test(e.key) || inputValue.length > 3 || parseInt(inputValue) > 100) {
              e.preventDefault(); // ป้องกันการป้อนค่าที่ไม่ใช่ตัวเลขหรือเกิน 3 ตัวอักษรหรือเกิน 100
            }
          }}
        />
      ),
    },
    {
      title: 'รับไม่เกิน (บาท)',
      dataIndex: 'payrate_user_blockprice',
      key: 'payrate_user_blockprice',
      render: (text: any, record: any) => {
        // console.log('text', text);
        // console.log('action', action);
        // console.log('showModalViewOnly', isModalVisibleViewOnly);
        if (isModalVisibleViewOnly === false) {
          return (
            <Input
              value={text} // Use value instead of defaultValue
              disabled={record?.payrate_user_user_id === parseDataUser?.id}
              style={{ color: '#000000' }}
              onChange={e => {
                const value = e.target.value.replace(/\D/g, '');
                handleInputChange(value, record.lottery_type_id, record.payrate_user_type_id, 'payrate_user_blockprice');
              }}
              onKeyPress={e => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          );
        } else {
          return <></>;
        }
      },
    },
  ];

  //  const tabs: any = Object.keys(tabData).map((key: any) => (
  //    <Tabs.TabPane tab={`${tabData[key].lottery_type_name}`} key={key}>
  //      <StyledInDetailTableDealer columns={columns} dataSource={tabData[key].payrate_data} pagination={false} />
  //    </Tabs.TabPane>
  //  ));

  const tabs: any = Object.keys(tabData).map((key: any) => (
    <Tabs.TabPane tab={`${tabData[key].lottery_type_name}`} key={key}>
      <StyledInDetailTableDealer columns={columns} dataSource={tabData[key].payrate_data} pagination={false} />
    </Tabs.TabPane>
  ));

  const fetchGetDealerMappingMyRegister = useCallback(
    async (query?: any) => {
      try {
        const responseData = await getDealerMappingMyRegister({ token });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setMyRegisterDealer(data?.data);
        } else {
          setMyRegisterDealer([]);
        }
      } catch (error) {}
    },
    [token],
  );

  const fetchGetDealerMappingMyIncome = useCallback(
    async (query?: any) => {
      try {
        const responseData = await getDealerMappingMyIncome({ token });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setMyIncomeDealer(data?.data);
        } else {
          setMyIncomeDealer([]);
        }
      } catch (error) {}
    },
    [token],
  );

  useEffect(() => {
    if (token) {
      fetchGetDealerMappingMyRegister();
      fetchGetDealerMappingMyIncome();
    }
  }, [token]);

  const handleGenerateKey = async () => {
    const updateData = await updateMappingGenerateKey({ token });
    if (updateData.status === 200) {
      Swal.fire({
        icon: 'success',
        title: 'ขอคีย์สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
      await setShowKryGenerate(updateData?.data?.data);
      await setSelectedDealer(null);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'ขอคีย์ไม่สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };
  const handleRegister = async () => {
    if (!registrationKey) {
      Swal.fire({
        icon: 'error',
        title: 'กรุณากรอกข้อมูลคีย์',
        showConfirmButton: false,
        timer: 5000,
      });
      return false;
    }
    const params = {
      dealer_user_id: Number(parseDataUser?.id),
      dealer_mapping_key: String(registrationKey),
    };
    const updateData = await postRegisterDealer({ token, params: params });
    if (updateData.status === 200) {
      Swal.fire({
        icon: 'success',
        title: 'ขอสมัครดีลเลอร์สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
      await fetchGetDealerMappingMyRegister();
      await setSelectedDealer(null);
    } else {
      Swal.fire({
        icon: 'error',
        title: updateData?.data?.message ? updateData?.data?.message : 'ขอสมัครดีลเลอร์ไม่สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    }
    // ฟังก์ชันบันทึกสถานะ
    // alert(`Status saved: ${status}`);
  };

  const statusTags: any = {
    wait: { className: 'wait', text: 'รอ' },
    approve: { className: 'approve', text: 'อนุมัติ' },
    notapprove: { className: 'not-approve', text: 'ไม่อนุมัติ' },
  };

  const DealerStatusTag = ({ status }: any) => {
    const tagProps = statusTags[status] || {
      className: 'default',
      text: status,
    };
    return <StyledTag className={tagProps.className}>{tagProps.text}</StyledTag>;
  };

  const statusTagsIncome: any = {
    Y: { className: 'approve', text: 'เปิดรับ' },
    N: { className: 'not-approve', text: 'ปิดรับ' },
  };

  const DealerStatusTagIncome = ({ status }: any) => {
    const tagProps = statusTagsIncome[status] || {
      className: 'default',
      text: status,
    };
    return <StyledTag className={tagProps.className}>{tagProps.text}</StyledTag>;
  };

  const handleApproveAndNotApprove = async (id: number, status: string) => {
    let textShow = '';
    if (status === 'approve') {
      textShow = 'คุณต้องการอนุมัติ ใช่หรือไม่!';
    } else {
      textShow = 'คุณต้องการไม่อนุมัติ ใช่หรือไม่!';
    }
    SwalAlert({
      icon: '',
      svgIcon: 'warning',
      header: textShow,
      title: ``,
      // title: item === 'link' ? $t('RemoveLinkLable') : $t('RemoveFileLable'),
      timer: false,
      showConfirmButton: true,
      showCloseButton: false,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: Color.greenDarken1,
      then: async (res: any) => {
        if (res.isConfirmed) {
          const params = {
            id: Number(id),
            dealer_mapping_status: status,
          };
          const updateData = await updateMappingUpdateStatus({
            token,
            params: params,
          });
          if (updateData.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'อัปเดตสำเร็จ',
              showConfirmButton: false,
              timer: 5000,
            });
            await fetchGetDealerMappingMyIncome();
            await setSelectedDealer(null);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'อัปเดตสำเร็จ',
              showConfirmButton: false,
              timer: 5000,
            });
          }
        }
      },
    });

    // ฟังก์ชันบันทึกสถานะ
    // alert(`Status saved: ${status}`);
  };

  const handleDelete = async (id: number) => {
    SwalAlert({
      icon: '',
      svgIcon: 'warning',
      header: 'คุณต้องการลบข้อมูลคีย์นี้ ใช่หรือไม่',
      title: ``,
      // title: item === 'link' ? $t('RemoveLinkLable') : $t('RemoveFileLable'),
      timer: false,
      showConfirmButton: true,
      showCloseButton: false,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: Color.greenDarken1,
      then: async (res: any) => {
        if (res.isConfirmed) {
          const deleteData = await deleteMapping({ token, id });
          if (deleteData.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'ลบสำเร็จ',
              showConfirmButton: false,
              timer: 5000,
            });
            await fetchGetDealerMappingMyIncome();
            await setSelectedDealer(null);
            await fetchShowGenerateKey();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'ลบไม่สำเร็จ',
              showConfirmButton: false,
              timer: 5000,
            });
          }
        }
      },
    });
  };

  const setPriceDataArray = async (data: any) => {
    const filterData = dataPayrateList?.filter((f: any) => f.id === data)[0];
    const params = {
      payrate_group_id: Number(filterData?.payrate_group_id),
      order_by: 'payrate_type_id',
      order_type: 'ASC',
    };
    const responseData = await getPayrateAll({ token, params: params });
    const dataArray = await responseData?.data?.data?.payrate;

    const updatedTabData = { ...tabData };
    if (activeTab && updatedTabData[activeTab]) {
      updatedTabData[activeTab].payrate_data = updatedTabData[activeTab].payrate_data.map((item: any) => {
        const updatedItem = dataArray.find((d: any) => d.payrate_type_slug === item.payrate_user_type_slug);
        if (updatedItem) {
          return {
            ...item,
            payrate_user_price: updatedItem.payrate_price,
            payrate_user_discount: updatedItem.payrate_discount,
          };
        }
        return item;
      });
    }

    setTabData({ ...updatedTabData });

    // Reset the selected option after updating the data
    setSelectedPayrate(null);

    setTimeout(() => {
      form.setFieldsValue({
        payrate_list: null,
      });
    }, 1500);
  };

  const onUpdateStatus = async (e: any) => {
    const value = e.target.value;
    if (value === 'Y') {
      SwalAlert({
        icon: '',
        svgIcon: 'warning',
        header: 'คำเตือน !!!',
        title: `
               การเปิดให้แทงยอดเกินได้จะไม่สนใจยอดตั้งรับของท่าน <br/> 
               ท่านแน่ใจและยินยอมรับความเสี่ยงหรือไม่ <br/>
               หากคุณมียอดบล็อคกับสมาชิก จะถูกเคลียร์ออกทั้งหมด
            `,
        // title: item === 'link' ? $t('RemoveLinkLable') : $t('RemoveFileLable'),
        timer: false,
        showConfirmButton: true,
        showCloseButton: false,
        confirmButtonText: 'ยอมรับความเสี่ยง',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: Color.danger,
        then: async (res: any) => {
          if (res.isConfirmed) {
            setChecked(value);
            // form.setFieldsValue({
            //   beyond_balance: 'Y',
            // });
          } else {
            setChecked('N');
            // form.setFieldsValue({
            //   beyond_balance: 'N',
            // });
          }
        },
      });
    } else {
      setChecked(value);
    }
  };

  const renderShowActionMyDealer = (status: string, id: number, dealer_user: number, owner_id: number, action: string) => {
    // console.log('dealerDataShowPopUp', dealerDataShowPopUp)
    if (status === 'wait' && action === 'update') {
      return (
        <Space size={10}>
          {/* <ApproveButton type='button'
                  onClick={() => {handleApproveAndNotApprove(id, 'approve')}}
               > อนุมัติ</ApproveButton>
               <NotApproveButton type='button'
                  onClick={() => {handleApproveAndNotApprove(id, 'notapprove')}}
               > ไม่อนุมัติ </NotApproveButton> */}
        </Space>
      );
    } else if (status === 'approve') {
      return (
        <Space size={10}>
          <DetailButton
            type="button"
            onClick={() => {
              if (action === 'update') {
                showModal(dealer_user, owner_id, action);
              }
            }}
          >
            <DetailIconDealer />
            {action === 'view' ? 'ดูรายละเอียด' : ' ตั้งค่า | ดูรายละเอียด'}
          </DetailButton>
          <StyledModal
            closeIcon={false}
            title="ข้อมูลดีลเลอร์"
            visible={isModalVisible}
            // onOk={handleOk}
            onCancel={handleCancel}
            width={1300} // กำหนดความกว้างของ Modal
            footer={[
              <>
                <Button key="cancel" onClick={handleCancel} className="ant-btn">
                  {action === 'update' ? 'ยกเลิก' : 'ปิด'}
                </Button>
                {showEdit && (
                  <Button key="ok" type="primary" onClick={() => handleOk(action)} className="ant-btn">
                    อัปเดต
                  </Button>
                )}
              </>,
            ]}
          >
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <span style={{ fontWeight: 500 }}>ชื่อเรียก:</span>
                <Input
                  type="text"
                  size="large"
                  value={nickname}
                  disabled={thisMyUserId !== parseDataUser?.id ? false : true}
                  onChange={handleNicknameChange}
                  style={{
                    marginLeft: '8px',
                    padding: '4px',
                    borderRadius: '4px',
                    border: '1px solid #d9d9d9',
                  }}
                />
              </Col>
              {thisMyUserId !== parseDataUser?.id ? (
                <>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินสูงสุด:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits_limit)}{' '}
                    <PastelButton type="button" onClick={showMaxCreditModal}>
                      ปรับวงเงินสูงสุด
                    </PastelButton>
                  </Col>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินที่ใช้ได้:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits)}{' '}
                    <PastelButton type="button" onClick={showAvailableCreditModal}>
                      ปรับวงเงินที่ใช้ได้
                    </PastelButton>
                  </Col>
                </>
              ) : (
                <>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินสูงสุด:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits_limit)}{' '}
                  </Col>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินที่ใช้ได้:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits)}{' '}
                  </Col>
                </>
              )}
            </Row>
            {/* <div className="mt-3" /> */}
            {thisMyUserId !== parseDataUser?.id && (
              <>
                <Space size={10}>
                  <label htmlFor="payrate-select">อัตราจ่าย</label>
                  <Select
                    style={{ width: '300px' }}
                    placeholder="กรุณาเลือก รายการ: อัตราจ่าย"
                    value={selectedPayrate}
                    onChange={(e, option: any) => {
                      setSelectedPayrate(e);
                      setPriceDataArray(e);
                    }}
                  >
                    {renderPayrateList()}
                  </Select>
                  สถานะการเปิดรับดีลเลอร์คนนี้ :
                  <StyledRadioGroup onChange={e => setPayrateStatus(e.target.value)} value={payrateStatus}>
                    <StyledRadioButton value="Y">เปิดรับ</StyledRadioButton>
                    <StyledRadioButton value="N">ปิดรับ</StyledRadioButton>
                  </StyledRadioGroup>
                </Space>
                <Space size={10} className="mt-2">
                  เปิดให้แทงเกินยอดได้ :
                  <PastelRadioGroup options={options} onChange={onUpdateStatus} value={checked} />
                </Space>
              </>
            )}

            <div className="mt-4" />
            <StyledTabsDealer onChange={key => setActiveTab(key)} defaultActiveKey="1">
              {tabs}
            </StyledTabsDealer>
          </StyledModal>
        </Space>
      );
    }
  };

  const renderShowActionMyDealerViewOnly = (status: string, id: number, dealer_user: number, owner_id: number, action: string) => {
    // console.log('dealerDataShowPopUp', dealerDataShowPopUp)
    if (status === 'wait' && action === 'update') {
      return (
        <Space size={10}>
          {/* <ApproveButton type='button'
                  onClick={() => {handleApproveAndNotApprove(id, 'approve')}}
               > อนุมัติ</ApproveButton>
               <NotApproveButton type='button'
                  onClick={() => {handleApproveAndNotApprove(id, 'notapprove')}}
               > ไม่อนุมัติ </NotApproveButton> */}
        </Space>
      );
    } else if (status === 'approve') {
      return (
        <Space size={10}>
          <DetailButton
            type="button"
            onClick={() => {
              if (action === 'view') {
                showModalViewOnly(dealer_user, owner_id, action);
              }
            }}
          >
            <DetailIconDealer />
            {action === 'view' ? 'ดูรายละเอียด' : ' ตั้งค่า | ดูรายละเอียด'}
          </DetailButton>
          <StyledModal
            closeIcon={false}
            title="ข้อมูลดีลเลอร์"
            visible={isModalVisibleViewOnly}
            // onOk={handleOk}
            onCancel={handleCancelViewOnly}
            width={1300} // กำหนดความกว้างของ Modal
            footer={[
              <>
                <Button key="cancel" onClick={handleCancelViewOnly} className="ant-btn">
                  {action === 'update' ? 'ยกเลิก' : 'ปิด'}
                </Button>
                {showEdit && (
                  <Button key="ok" type="primary" onClick={() => handleOk(action)} className="ant-btn">
                    อัปเดต
                  </Button>
                )}
              </>,
              // <Button key="cancel" onClick={handleCancel} className="ant-btn">
              //   {action === "update" ? "ยกเลิก" : "ปิด"}
              // </Button>,
              // action === "update" && (
              //   <Button key="ok" type="primary" onClick={handleOk} className="ant-btn">
              //     อัปเดต
              //   </Button>
              // ),
            ]}
          >
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <span style={{ fontWeight: 500 }}>ชื่อเรียก:</span>
                <Input
                  type="text"
                  size="large"
                  value={nickname}
                  disabled={thisMyUserId !== parseDataUser?.id ? false : true}
                  onChange={handleNicknameChange}
                  style={{
                    marginLeft: '8px',
                    padding: '4px',
                    borderRadius: '4px',
                    border: '1px solid #d9d9d9',
                  }}
                />
              </Col>
              {/* {thisMyUserId !== parseDataUser?.id ? (
                <>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินสูงสุด:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits_limit)}{' '}
                    <PastelButton type="button" onClick={showMaxCreditModal}>
                      ปรับวงเงินสูงสุด
                    </PastelButton>
                  </Col>
                  <Col span={6}>
                    <span style={{ fontWeight: 500 }}>วงเงินที่ใช้ได้:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits)}{' '}
                    <PastelButton type="button" onClick={showAvailableCreditModal}>
                      ปรับวงเงินที่ใช้ได้
                    </PastelButton>
                  </Col>
                </>
              ) : ( */}
              <>
                <Col span={6}>
                  <span style={{ fontWeight: 500 }}>วงเงินสูงสุด:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits_limit)}{' '}
                </Col>
                <Col span={6}>
                  <span style={{ fontWeight: 500 }}>วงเงินที่ใช้ได้:</span> {NumberFormat(dealerDataShowPopUp?.dealer_mapping_credits)}{' '}
                </Col>
              </>
              {/* )} */}
            </Row>
            <div className="mt-3" />
            {/* {thisMyUserId !== parseDataUser?.id && (
              <>
                <Space size={10}>
                  <label htmlFor="payrate-select">อัตราจ่าย</label>
                  <Select
                    style={{ width: '300px' }}
                    placeholder="กรุณาเลือก รายการ: อัตราจ่าย"
                    value={selectedPayrate}
                    onChange={(e, option: any) => {
                      setSelectedPayrate(e);
                      setPriceDataArray(e);
                    }}
                  >
                    {renderPayrateList()}
                  </Select>
                  สถานะการเปิดรับดีลเลอร์คนนี้ :
                  <StyledRadioGroup onChange={e => setPayrateStatus(e.target.value)} value={payrateStatus}>
                    <StyledRadioButton value="Y">เปิดรับ</StyledRadioButton>
                    <StyledRadioButton value="N">ปิดรับ</StyledRadioButton>
                  </StyledRadioGroup>
                </Space>
                <Space size={10} className="mt-2">
                  เปิดให้แทงเกินยอดได้ :
                  <PastelRadioGroup
                    options={options}
                    onChange={onUpdateStatus}
                    value={checked}
                  />
                </Space>
              </>
            )} */}

            <div className="mt-4" />
            <StyledTabsDealer onChange={key => setActiveTab(key)} defaultActiveKey="1">
              {tabs}
            </StyledTabsDealer>
          </StyledModal>
        </Space>
      );
    }
  };

  const handleCopy = () => {
    message.success('Copied to clipboard!');
  };

  const handleMaxCreditChange = (e: any) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setMaxCreditLimit(value);
      // Update availableCredit if it exceeds the new maxCreditLimit
      if (Number(availableCredit) > Number(value)) {
        setAvailableCredit(value);
      }
    }
  };

  const handleAvailableCreditChange = (e: any) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && Number(value) <= Number(maxCreditLimit)) {
      setAvailableCredit(value);
    }
  };

  return (
    <Container>
      <Section>
        <Header>สร้างคีย์ในการผูกดีลเลอร์</Header>
        <StatusContainer>
          <StatusLabel htmlFor="status">แสดงคีย์:</StatusLabel>
          <span>{showKeyGenerate}</span>
          {showKeyGenerate && (
            <CopyToClipboard text={showKeyGenerate} onCopy={handleCopy}>
              <Tooltip title="Copy to clipboard">
                <Button icon={<CopyOutlined />} style={{ marginLeft: '8px' }}>
                  Copy
                </Button>
              </Tooltip>
            </CopyToClipboard>
          )}

          <SaveButton
            onClick={() => {
              setIsModalGenerateKeyVisible(true);
              setDealerUserId(0);
              setDealerDataShowPopUp([]);
              setPayrateStatus('');
              setMaxCredit('');
              setAvailableCredit('');
              setNickname('');
              setDealerDataShowPopUp([]);
              setTableData([]);
            }}
          >
            Generate Key
          </SaveButton>

          <SaveButton onClick={() => setIsModalShowGenerateKey(true)}>ดูข้อมูลคีย์ ของคุณ</SaveButton>
        </StatusContainer>
      </Section>

      <Section className="table table-responsive">
        <Header>ข้อมูลดีลเลอร์ของคุณ</Header>
        <DealerTable>
          <thead>
            <tr>
              <TableHeader align="center">ชื่อเรียก</TableHeader>
              <TableHeader align="center">ชื่อ</TableHeader>
              <TableHeader align="center">ยูสเซอร์</TableHeader>
              <TableHeader align="center">วงเงินเครดิต</TableHeader>
              <TableHeader align="center">เครดิตคงเหลือ</TableHeader>
              <TableHeader align="center">สถานะ</TableHeader>
              <TableHeader align="center">การเปิดรับยอด</TableHeader>
              <TableHeader align="center">Action</TableHeader>
            </tr>
          </thead>
          <tbody>
            {myIncomeDealer?.map((dealer: any) => {
              return (
                <TableRow key={dealer.owner_id}>
                  <TableCell>{dealer?.dealer_name}</TableCell>
                  <TableCell>
                    {dealer?.dealer_data?.name} {dealer?.dealer_data?.lastname}
                  </TableCell>
                  <TableCell>{dealer?.dealer_data?.username}</TableCell>
                  <TableCell>{NumberFormat(dealer?.dealer_mapping_credits_limit)}</TableCell>
                  <TableCell>{NumberFormat(dealer?.dealer_mapping_credits)}</TableCell>
                  <TableCell>
                    <DealerStatusTag status={dealer.dealer_mapping_status} />
                  </TableCell>
                  <TableCell>
                    <DealerStatusTagIncome status={dealer.dealer_mapping_status_income} />
                  </TableCell>
                  <TableCell>
                    {renderShowActionMyDealer(dealer.dealer_mapping_status, dealer.id, dealer?.dealer_user_id, dealer?.owner_id, 'update')}
                  </TableCell>
                </TableRow>
              );
            })}
          </tbody>
        </DealerTable>
      </Section>

      <Section>
        <Header>กรอกคีย์สำหรับการสมัครดีลเลอร์</Header>
        <DropdownContainer>
          <Input size="large" placeholder="กรอกคีย์สมัคร" value={registrationKey} onChange={handleInputChangeRegisterKey} />

          <RegisterButtton onClick={handleRegister}>สมัคร</RegisterButtton>
        </DropdownContainer>
      </Section>

      <Section className="table table-responsive">
        <Header>ข้อมูลดีลเลอร์ที่คุณสมัคร</Header>
        <DealerTable>
          <thead>
            <tr>
              {/* <TableHeader align='center'>ชื่อเรียก</TableHeader> */}
              <TableHeader align="center">ชื่อ</TableHeader>
              <TableHeader align="center">ยูสเซอร์</TableHeader>
              <TableHeader align="center">วงเงินเครดิต</TableHeader>
              <TableHeader align="center">เครดิตคงเหลือ</TableHeader>
              <TableHeader align="center">สถานะ</TableHeader>
              <TableHeader align="center">Action</TableHeader>
            </tr>
          </thead>
          <tbody>
            {myRegisterDealer?.map((dealer: any) => {
              // console.log('dealer', dealer)
              return (
                <TableRow key={dealer.dealer_user_id}>
                  {/* <TableCell>{dealer?.dealer_name}</TableCell> */}
                  <TableCell>
                    {dealer?.owner_data.name} {dealer?.owner_data.lastname}
                  </TableCell>
                  <TableCell>{dealer?.owner_data.username}</TableCell>
                  <TableCell>{NumberFormat(dealer?.dealer_mapping_credits)}</TableCell>
                  <TableCell>{NumberFormat(dealer?.dealer_mapping_credits_limit)}</TableCell>
                  <TableCell>
                    <DealerStatusTag status={dealer.dealer_mapping_status} />
                  </TableCell>
                  <TableCell>
                    {renderShowActionMyDealerViewOnly(dealer.dealer_mapping_status, dealer.id, dealer?.dealer_user_id, dealer?.owner_id, 'view')}
                  </TableCell>
                </TableRow>
              );
            })}
          </tbody>
        </DealerTable>
      </Section>
      <Modal title="ปรับวงเงินสูงสุด" visible={isMaxCreditModalVisible} onOk={handleMaxCreditOk} onCancel={handleMaxCreditCancel}>
        <Input value={maxCredit} type="number" onChange={e => onChangeInputValue(e, 'credits_limit')} placeholder="ปรับวงเงินสูงสุด" />
      </Modal>
      <Modal
        title="ปรับวงเงินที่ใช้ได้"
        visible={isAvailableCreditModalVisible}
        onOk={handleAvailableCreditOk}
        onCancel={handleAvailableCreditCancel}
      >
        <Input value={availableCredit} type="number" onChange={e => onChangeInputValue(e, 'credits')} placeholder="ปรับวงเงินที่ใช้ได้" />
      </Modal>

      <StyledModal
        closeIcon={false}
        title="สร้างคีย์สำหรับส่งดีลเลอร์"
        visible={isModalGenerateKeyVisible}
        onOk={handleGenerateKeyOk}
        onCancel={handleGenerateKeyCancel}
        width={1300} // กำหนดความกว้างของ Modal
        footer={[
          <Button key="cancel" onClick={handleGenerateKeyCancel} className="ant-btn">
            ปิด
          </Button>,
          <Button key="ok" type="primary" onClick={handleGenerateKeyOk} className="ant-btn">
            สร้างข้อมูล
          </Button>,
        ]}
      >
        <StatusLabel htmlFor="status">แสดงคีย์:</StatusLabel>
        <span>{showKeyGenerate}</span>
        {showKeyGenerate && (
          <CopyToClipboard text={showKeyGenerate} onCopy={handleCopy}>
            <Tooltip title="Copy to clipboard">
              <Button icon={<CopyOutlined />} style={{ marginLeft: '8px' }}>
                Copy
              </Button>
            </Tooltip>
          </CopyToClipboard>
        )}
        <SaveButton disabled={!!showKeyGenerate} onClick={handleGenerateKey}>
          Generate Key
        </SaveButton>

        <div className="mt-3" />
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <span style={{ fontWeight: 500 }}>ชื่อเรียก:</span>
            <Input
              type="text"
              size="large"
              disabled={thisMyUserId !== parseDataUser?.id ? false : true}
              value={nickname}
              onChange={handleNicknameChange}
              style={{
                marginLeft: '8px',
                padding: '4px',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
              }}
            />
          </Col>
          <Col span={6}>
            <span style={{ fontWeight: 500 }}>วงเงินสูงสุด:</span>
            <Input
              type="text"
              size="large"
              value={maxCreditLimit}
              onChange={handleMaxCreditChange}
              style={{
                marginLeft: '8px',
                padding: '4px',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
              }}
            />
          </Col>
          <Col span={6}>
            <span style={{ fontWeight: 500 }}>วงเงินที่ใช้ได้:</span>
            <Input
              type="text"
              size="large"
              value={availableCredit}
              onChange={handleAvailableCreditChange}
              style={{
                marginLeft: '8px',
                padding: '4px',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
              }}
            />
          </Col>
        </Row>
        <div className="mt-3" />
        {thisMyUserId !== parseDataUser?.id && (
          <Space size={10}>
            <label htmlFor="payrate-select">อัตราจ่าย</label>
            <Select
              style={{ width: '300px' }}
              placeholder="กรุณาเลือก รายการ: อัตราจ่าย"
              value={selectedPayrate}
              onChange={(e, option: any) => {
                setSelectedPayrate(e);
                setPriceDataArray(e);
              }}
            >
              {renderPayrateList()}
            </Select>
            สถานะการเปิดรับดีลเลอร์คนนี้ :
            <StyledRadioGroup onChange={e => setPayrateStatus(e.target.value)} value={payrateStatus}>
              <StyledRadioButton value="N">ปิดรับ</StyledRadioButton>
              <StyledRadioButton value="Y">เปิดรับ</StyledRadioButton>
            </StyledRadioGroup>
          </Space>
        )}

        <div className="mt-4" />
        <StyledTabsDealer onChange={key => setActiveTab(key)} defaultActiveKey="1">
          {tabs}
        </StyledTabsDealer>
      </StyledModal>

      <StyledModal
        closeIcon={false}
        title="ข้อมูลคีย์ของคุณ"
        visible={isModalShowGenerateKey}
        // onOk={handleGenerateKeyOk}
        onCancel={handleShowGenerateKeyCancel}
        width={800} // กำหนดความกว้างของ Modal
        footer={[
          <Button key="cancel" onClick={handleShowGenerateKeyCancel} className="ant-btn">
            ปิด
          </Button>,
        ]}
      >
        <Row gutter={[16, 16]}>
          {dataShowKey?.map((keyData: any) => (
            <Col span={12} key={keyData.id}>
              <div>
                <p>
                  <strong>ชื่อเรียก :</strong> {keyData?.dealer_name}
                </p>
                <p>
                  <strong>ยูสเซอร์ :</strong> {keyData?.dealer_data?.username}
                </p>
                <p>
                  <strong>คีย์ :</strong> {keyData?.dealer_mapping_key}
                </p>
                {keyData.dealer_user_id === null ? (
                  <>
                    <p style={{ color: 'red' }}>
                      <strong>สถานะ :</strong> ยังไม่ถูกใช้
                    </p>
                    <Space>
                      <Button
                        // type="danger"
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(keyData.id)}
                      >
                        ลบ
                      </Button>
                      <CopyToClipboard text={keyData?.dealer_mapping_key} onCopy={handleCopy}>
                        <Tooltip title="Copy to clipboard">
                          <Button icon={<CopyOutlined />}>Copy</Button>
                        </Tooltip>
                      </CopyToClipboard>
                    </Space>
                  </>
                ) : (
                  <p style={{ color: 'green' }}>
                    <strong>สถานะ :</strong> ถูกใช้แล้ว
                  </p>
                )}
              </div>
            </Col>
          ))}
        </Row>
      </StyledModal>
    </Container>
  );
};

export default DealerComponents;
